/**
 * Tiny analytics helper — server-side event capture via /api/analytics/event.
 * Use anywhere on the client to record an interaction (SMS clicks, form submits, etc).
 *
 *  trackEvent("sms_recruiter_click", { path: "/clinicians" });
 *
 * Whitelisted event names (must match backend ALLOWED_EVENTS):
 *   request_talent_submit · clinician_signup_submit · facility_signup_submit
 *   checklist_submit · prn_shift_apply · sms_recruiter_click · sms_compliance_click
 *   contact_form_submit · career_form_submit · newsletter_signup
 */
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function trackEvent(event, properties = {}) {
  try {
    await fetch(`${API}/analytics/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event, properties }),
      // Use keepalive so the request survives a navigation away (clicking sms: href)
      keepalive: true,
    });
  } catch {
    /* silently swallow — analytics must never block UX */
  }
}
